module.exports = __webpack_public_path__ + "static/img/download.51912436.png";